import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, FormControl, EmailValidator, Validators } from "@angular/forms";
import { ServiceService } from '../../service.service';
import { CombineLatestOperator } from 'rxjs/internal/observable/combineLatest';

declare var $;


@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})


export class FooterComponent implements OnInit {
    isCookieaccepted;
    email: any;
    bookmsg: string;
    getintouchmsg: string;
    email_sent: any;
    submitted: boolean;
    GITsubmitted: boolean;
    minDate: Date;
    maxDate: Date;
    data_user: any;
    currentDate: any;
    getInTouchFormdata: any;
    constructor(private http: HttpClient, public fb: FormBuilder, public service: ServiceService,) {
        this.minDate = new Date();
        this.maxDate = new Date();
        this.minDate.setDate(this.minDate.getDate());
        this.maxDate.setDate(this.maxDate.getDate() + 30);
    }

    ngOnInit() {
        this.isCookieaccepted =  window.localStorage.getItem('isCookieaccepted')
        console.log(this.isCookieaccepted);
        
        // get in touch trigger after 3 min.
        setTimeout(function () {
            $("#getintouch").modal()
        }, 90000);
    }

    // Book a Demo form validation
        contact_form = new FormGroup({
        name: new FormControl('', [Validators.required]),
        email: new FormControl('', [Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]),
        country_code: new FormControl(''),
        mobile: new FormControl(''),
        date: new FormControl('', [Validators.required]),
        time: new FormControl('', [Validators.required]),
        purpose: new FormControl('', [Validators.required])

    });

    get f1() {
        return this.contact_form.controls;
    }

    // submit book a demo form
    submitForm() {
        setTimeout(function () {
            $("#book_msg").hide();
        }, 1000);
        this.submitted = true;
        if (this.contact_form.invalid) {
            return;
        }

        //console.log(this.contact_form.value);
        this.email_sent = {
            name: this.contact_form.value.name,
            email: this.contact_form.value.email,
            date: this.contact_form.value.date,
            mobile: this.contact_form.value.mobile,
            country_code: this.contact_form.value.country_code,
            time: this.contact_form.value.time,
            purpose: this.contact_form.value.purpose,
        }
        
        this.bookmsg = "Your Demo has booked , Check your email for further updates...!!!!";

        this.service.bookDemo(this.email_sent)
        .subscribe((data:any[])=>{})
        error => {
            console.log('no request generated');
        }

        this.contact_form.reset();
        //console.log(this.email_sent);
        this.service.email_book_details(this.email_sent)
            .subscribe((data: any[]) => {
            })
        error => {
            console.log('no data found');
        }
        // this.thankyou(this.email_sent)

        setTimeout(function () {
            $('#callBack').modal('hide')
        }, 2000);

        // this.contact_form.reset;

    }


    // User reply mail API
    // thankyou(values){
    // this.service.user_thanks(values).subscribe((data: any[]) => {
    // })
    // error => {
    // console.log('no data found');
    // }
    // }

    // privacy page reload function when click from book a demo form
    privacyLoad() {
        setTimeout(function () {
            window.location.reload();
        }, 100)
    }


    //getInTouchForm Form Validation

    getInTouchForm = new FormGroup({
        name: new FormControl("", [Validators.required]),
        email: new FormControl("", [Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]),
        mobile: new FormControl(" "),

    });

    get f() {
        return this.getInTouchForm.controls;
    }

    submitgetInTouchForm() {

        this.GITsubmitted = true;
        if (this.getInTouchForm.invalid) {
            return;
        }
        console.log(this.getInTouchForm.value);

        this.getInTouchFormdata = {

            name: this.getInTouchForm.value.name,
            email: this.getInTouchForm.value.email,
            mobile: this.getInTouchForm.value.mobile ? this.getInTouchForm.value.mobile : '',

        }


        this.service.getInTouchMail(this.getInTouchFormdata)
            .subscribe((data: any[]) => {
            })
        error => {
            console.log('no data found');
        }

        this.getintouchmsg = 'We will get back to you shortly.'

        setTimeout(function () {
            $('#getintouch').modal('hide')
        }, 500);

    }
    
    //================================ Accept Cookie Policy ===============================================
    acceptCookiePolicy(){
      window.localStorage.setItem('isCookieaccepted','true')

    }



}
